import { render, staticRenderFns } from "./AcessosUsuario.vue?vue&type=template&id=10717dfc&scoped=true"
import script from "./AcessosUsuario.vue?vue&type=script&lang=js"
export * from "./AcessosUsuario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10717dfc",
  null
  
)

export default component.exports